@if (actionConfig) {
  <oaibox-warning-message-card
    [gradient]="actionConfig.gradientColor"
    confirmText="Proceed"
    (confirm$)="confirmAction()"
    (cancel$)="discard()"
  >
    <div messageTitle>
      Are you sure you want to
      <b
        ><i class="{{ actionConfig.icon }} white"></i>
        {{ actionConfig.name }}</b
      >?
    </div>
    <div messageBody class="message-body">
      <p>{{ actionConfig.config.message }}</p>
    </div>
  </oaibox-warning-message-card>
}
